const AUTH_SYNC_EVENT_KEY = 'auth_sync_event';
const AUTH_SESSION_SNAPSHOT_KEY = 'auth_session_snapshot';
const TAB_SESSION_KEY = 'tab_session_id';
const TAB_FORCE_LOGOUT_KEY = 'tab_force_logout';

const AUTH_KEYS = new Set([
  'access_token',
  'token_type',
  'authId',
  'ID',
  'client_id',
  'user_type'
]);

const safeParse = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const createId = () => `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

const getAuthStorageItem = (key) => {
  const sessionValue = sessionStorage.getItem(key);
  if (sessionValue !== null) return sessionValue;
  return localStorage.getItem(key);
};

export const ensureTabSessionId = () => {
  const existing = sessionStorage.getItem(TAB_SESSION_KEY);
  if (existing) return existing;
  const next = createId();
  sessionStorage.setItem(TAB_SESSION_KEY, next);
  return next;
};

export const buildAuthSnapshot = (overrides = {}) => ({
  access_token: overrides.access_token ?? getAuthStorageItem('access_token'),
  token_type: overrides.token_type ?? getAuthStorageItem('token_type'),
  authId: overrides.authId ?? getAuthStorageItem('authId') ?? 0,
  ID: overrides.ID ?? getAuthStorageItem('ID'),
  client_id: overrides.client_id ?? getAuthStorageItem('client_id'),
  user_type: overrides.user_type ?? getAuthStorageItem('user_type'),
  tab_session_id: ensureTabSessionId()
});

export const hasActiveAuth = (snapshot) => Boolean(snapshot?.access_token) && parseInt(snapshot?.authId, 10) === 1;

export const persistAuthSnapshot = (snapshot) => {
  const next = buildAuthSnapshot(snapshot);
  sessionStorage.setItem(AUTH_SESSION_SNAPSHOT_KEY, JSON.stringify(next));
  return next;
};

export const getPersistedAuthSnapshot = () => safeParse(sessionStorage.getItem(AUTH_SESSION_SNAPSHOT_KEY));

export const clearPersistedAuthSnapshot = () => {
  sessionStorage.removeItem(AUTH_SESSION_SNAPSHOT_KEY);
};

export const markTabLoggedOut = () => {
  sessionStorage.setItem(TAB_FORCE_LOGOUT_KEY, '1');
};

export const clearTabLoggedOutMark = () => {
  sessionStorage.removeItem(TAB_FORCE_LOGOUT_KEY);
};

export const isTabMarkedLoggedOut = () => sessionStorage.getItem(TAB_FORCE_LOGOUT_KEY) === '1';

export const publishLogoutSyncEvent = (snapshot) => {
  const payload = {
    type: 'logout',
    event_id: createId(),
    at: Date.now(),
    auth: snapshot || getPersistedAuthSnapshot() || buildAuthSnapshot()
  };
  localStorage.setItem(AUTH_SYNC_EVENT_KEY, JSON.stringify(payload));
};

export const parseAuthSyncEvent = (value) => safeParse(value);

export const isAuthSyncEventKey = (key) => key === AUTH_SYNC_EVENT_KEY;

export const isRelevantAuthStorageKey = (key) => AUTH_KEYS.has(key);
